import { Component, Input } from '@angular/core';
import { IBodyCell, BodyCell } from '../../../holders/body-cell.component';
import { Selection } from '../../../../utility/selection.class';

@Component({
   selector: 'app-multi-selection',
   template: `
      <exi-checkbox [value]="value" [ctx]="cell.selection"></exi-checkbox>
   `,
   styleUrls: ['./multi.component.scss']
})
export class MultiSelectionCellComponent<D extends object> implements IBodyCell<D> {
   @Input() public value: D;
   @Input() public cell: MultiSelectionCell<D>;

}


export class MultiSelectionCell<D extends object> extends BodyCell<D> {
   constructor(
      public selection: Selection<D>
   ) {
      super(MultiSelectionCellComponent, () => ``);
   }
}
